export const GO_TO_INTERNAL_HREF = 'goToInternalHref'
export const SCROLL_TO_ID = 'scrollToID'
export const CONTENT_MODAL = 'modal'
